module.exports = __webpack_public_path__ + "img/film-estirable-5.a562407a.jpg";